import React, { ReactNode } from 'react'
import { IconButton, Link, ArrowLeftIcon } from '@paypalcorp/pp-react'

import { SHOPPING_PAGE } from '../../../../lib/client-constants'
interface Props {
  className?: string
  href?: string
  children?: ReactNode
  isVisible?: boolean
  fptiOnClick?: Function
  onClick?: Function
}

const BackLink = ({
  className,
  href,
  children,
  isVisible = true,
  fptiOnClick,
  onClick
}: Props) => {
  if (!isVisible) {
    return null
  }

  const backLinkStyle = className
    ? 'back-link--v2 ' + className
    : 'back-link--v2'
  const defaultBackActionUsingWindow = () => {
    window.location.href = `${window.location.origin}${SHOPPING_PAGE}`
    if (typeof fptiOnClick === 'function') {
      fptiOnClick()
    }
  }

  return (
    <IconButton
      theme="v2"
      as={Link}
      to={href}
      buttonType="tertiary"
      svgIconComponent={ArrowLeftIcon}
      className={backLinkStyle}
      onClick={onClick ? onClick : defaultBackActionUsingWindow}
    >
      {children}
    </IconButton>
  )
}

export default BackLink
